// extracted by css-extract-rspack-plugin
export default {"group":"NavGroup-module__group__W8SqJ","hasSeparator":"NavGroup-module__hasSeparator__FnMrN","title":"NavGroup-module__title__Wzxz2","list":"NavGroup-module__list__UCOFy"};